import React, { Component } from 'react';
import './label.scss';
import { GECKO_CONSTS } from '../../';
import { GeckoLabelModel } from '../../models';

class GeckoLabel extends Component {
  prepareClass() {
    return GECKO_CONSTS.LABEL_CLASSES[
      this.props.type || GECKO_CONSTS.LABEL_TYPE_DEFAULT
    ];
  }

  renderClass() {
    return `gecko-label badge ${this.prepareClass()}`;
  }

  render() {
    return <span className={this.renderClass()}>{this.props.name}</span>;
  }
}

GeckoLabel.propTypes = GeckoLabelModel;

export default GeckoLabel;
